import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const FooterLoadable = loadable(() => import('./Footer'), {
  resolveComponent: components => components.Footer
});

export const Footer = WithLazyHydration(FooterLoadable, { name: 'Footer' });
